import Prompter from './prompter.js';
let prompteInstance;

let seed = 0;
let parentEl = undefined;

// 生成一个id
function getUuid() {
  return 'bo-prompt__id' + seed;
}
// 获取prompt元素
function getPromptDom() {
  return document.querySelector('#' + getUuid());
}
// 获取父级元素
function getPromptParentDom() {
  if (!parentEl) {
    // 如果parentEl不存在， 则父级为body
    return document.body;
  }
  return isPromptParent();
}
// 判断prompt的父容器是否还存在
function isPromptParent() {
  return document.querySelector(parentEl);
}
// 删除prompt
function removePrompt() {
  prompteInstance && prompteInstance.destroy();
  const c = getPromptDom();
  if (!c) {
    return;
  }
  getPromptParentDom().removeChild(c);
}

// 重置实例信息，清除dom、实例， seed从新赋值
function resetIns(el) {
  removePrompt();
  seed++;
  parentEl = el;
  prompteInstance = null;
}

function getPrompteInstance(options) {
  // 如果父级容器发生变化重置所有信息
  parentEl !== options.el && resetIns(options.el);

  // 如果实例存在，父容器的值存在，单父容器的dom不存在，则重置所有信息
  if (parentEl && !isPromptParent()) {
    resetIns(options.el);
    throw ('找不到传入的el的dom');
  }

  // 如果实例存在，但是prompt元素不存在了
  prompteInstance && !getPromptDom() && resetIns(options.el);

  options.uid = getUuid();
  prompteInstance = prompteInstance || Prompter.newInstance(options);
  return prompteInstance;
}

let instance = null;
export default  {
  show(options = {}) {
    instance = getPrompteInstance(options);
    instance.updata(options);
    instance.show(options);
  },
  hide() {
    instance && instance.hide();
  },
  state() {
    return instance && instance.state();
  }
};
